import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'baseMinutesToShortTime' })
export class BaseMinutesToShortTimePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: number | undefined | null): string {
    if (value == null || isNaN(value)) {
      return '';
    }

    const hours = Math.floor(value / 60);
    const minutes = value % 60;

    const hoursPart = hours === 0 ? '' : `${hours}${this.translateService.instant('h')}`;
    const minutesPart = minutes === 0 ? '' : minutes < 10 && minutes >= 1 && hours > 0 ? `0${minutes}` : minutes;

    return !value || (hours <= 0 && minutes <= 0)
      ? '0min'
      : hours > 0
      ? `${hoursPart}${minutesPart}`
      : `${minutesPart}min`;
  }
}
